import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

export default function DetailsModal(props) {
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Listing Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3 className="details-modal__title"> Landlord Name:</h3>
          <p className="details-modal__text">{props.data.name}</p>
          <h3 className="details-modal__title"> Address:</h3>
          <p className="details-modal__text"> {props.data.address} </p>
          <p className="details-modal__title">Contact info</p>
          <p className="detail-modal__text">{props.data.Phone}</p>
          <p className="details-modal__text">{props.data.email}</p>
          <h3 className="details-modal__title"> Price:</h3>
          <p className="details-modal__text">${props.data.price} Monthly</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary">Save Changes</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
